import React from 'react';
import { TxButton, TxButtonMode } from '../../components/Button';
import { TxModal, TxModalFooter, TxModalHeader, TxModalBody, } from '../../components/Modal';
import MCVisaDiscover from './MCVisaDiscover';
import AmericanExpress from './AmericanExpress';
export const WhatsThisModal = ({ open, onClose, showAmex, spanish, }) => {
    const labels = {
        header: spanish ? '¿Qué es esto?' : "What's this?",
        subHeader: spanish
            ? 'Encuentre su código de seguridad/números CVV en su tarjeta.'
            : 'Find your security code/CVV numbers on your card.',
        mcVisaDiscover: spanish ? 'Mastercard, Visa y Discover' : 'Mastercard, Visa and Discover',
        mcVisaDiscoverDesc: spanish
            ? 'Número de tres dígitos que se encuentra en el reverso de su tarjeta'
            : 'Three-digit number found on the back of your card',
        amexDesc: spanish
            ? 'Número de cuatro dígitos que se encuentra en el frente de su tarjeta'
            : 'Four-digit number found on the front of your card',
        okButtonLabel: spanish ? 'OK, entiendo' : 'Ok, got it',
    };
    return (React.createElement(TxModal, { open: open, className: "tx-payment-card-form__whats-this-modal", onClose: onClose, showCloseBtn: true },
        React.createElement(TxModalHeader, null,
            React.createElement("span", { className: "whats-this-modal__header" }, labels.header)),
        React.createElement(TxModalBody, null,
            React.createElement("p", { className: "whats-this-modal__sub-header mb-5" }, labels.subHeader),
            React.createElement("div", { className: "whats-this-modal__card-display" },
                React.createElement("div", null,
                    React.createElement("div", { className: "whats-this-modal__card-display-header" }, labels.mcVisaDiscover),
                    React.createElement("div", { className: "whats-this-modal__card-description mb-3" }, labels.mcVisaDiscoverDesc),
                    React.createElement(MCVisaDiscover, { width: 288, height: 219 })),
                showAmex && (React.createElement("div", null,
                    React.createElement("div", { className: "whats-this-modal__card-display-header" }, "American Express"),
                    React.createElement("div", { className: "whats-this-modal__card-description mb-3" }, labels.amexDesc),
                    React.createElement(AmericanExpress, { width: 288, height: 219 }))))),
        React.createElement(TxModalFooter, null,
            React.createElement(TxButton, { type: "button", mode: TxButtonMode.Primary, onClick: onClose }, labels.okButtonLabel))));
};
//# sourceMappingURL=WhatsThisModal.js.map